import { makeAutoObservable, runInAction } from "mobx";

import Constants from "../../constants/Common";
import { debounce } from "lodash";

export class SearchFieldActions {
  text = "";
  debouncedText = "";

  constructor() {
    makeAutoObservable(this);
  }

  handleDebouncedChangeText = debounce(() => {
    runInAction(() => {
      this.debouncedText = this.text.trim().toLowerCase();
    });
  }, Constants.debounceValue);

  handleChangeText = (val) => {
    runInAction(() => {
      this.text = val;
      this.handleDebouncedChangeText();
    });
  };

  handleClearText = () => {
    runInAction(() => {
      this.text = "";
      this.handleDebouncedChangeText();
    });
  };
}
